import { Pipe, PipeTransform } from '@angular/core';
import { parseBackgroundTaskParams } from './background-task.utils';

@Pipe({
    name: 'backgroundTaskParams',
    pure: true,
})
export class BackgroundTaskParamsPipe implements PipeTransform {
    public transform(params: string | null): Record<string, unknown> | null {
        return parseBackgroundTaskParams(params);
    }
}
